import type React from 'react';
import { twMerge } from 'tailwind-merge';

const H3: React.FC<React.HTMLAttributes<HTMLHeadingElement>> = ({ className, children, ...props }) => (
  <h3 className={twMerge('text-xl leading-relaxed font-semibold', className)} {...props}>
    {children}
  </h3>
);

export default H3;
